/* unplugin-vue-components disabled */import __unplugin_components_2 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-button.vue';
import __unplugin_components_1 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-token.vue';
import __unplugin_components_0 from '/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/src/components/up-icon.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  id: "add-token-dialog"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "subtitle"
};
const _hoisted_4 = {
  key: 0,
  class: "my-tokens tokens"
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "top-100 tokens"
};
const _hoisted_7 = {
  class: "title"
};
import { getChainName, getChainNameByChainId } from '@/service/chains-config';
import { ADDRESS_ZERO } from '@/service/constants';
import { useCoinStore } from '@/store/coin';
import { useUserStore } from '@/store/user';
import { isSameAddress } from '@/utils/string-utils';
import { upError, upSuccess, isMobile } from '@/utils/useUniPass';
import { ElMessageBox } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  __name: 'add-token-dialog',
  emits: ["close", "addCustomToken"],

  setup(__props, {
    emit: $emit
  }) {
    const userStore = useUserStore();
    const coinStore = useCoinStore();
    const {
      t: $t
    } = useI18n();
    const myTokens = computed(() => coinStore.coins.filter(token => !isSameAddress(token.contractAddress, ADDRESS_ZERO)));
    const top100Tokens = computed(() => {
      var _coinStore$tokenLists;

      const chainId = userStore.chainId;
      const chainType = getChainNameByChainId(chainId);
      return (((_coinStore$tokenLists = coinStore.tokenLists[chainType]) === null || _coinStore$tokenLists === void 0 ? void 0 : _coinStore$tokenLists.slice(0, 100)) || []).map(token => {
        const added = !!coinStore.coins.find(addedTokens => {
          return isSameAddress(token.contractAddress, addedTokens.contractAddress);
        });
        return { ...token,
          added
        };
      });
    });

    const addToken = async _token => {
      try {
        const chainId = _token.chainId;
        coinStore.tokenLists[_token.chain] = coinStore.tokenLists[_token.chain].map(token => {
          if (isSameAddress(token.contractAddress, _token.contractAddress)) {
            return { ...token,
              loading: true
            };
          }

          return token;
        });
        await coinStore.addTokenToTokenList(chainId, _token);
        upSuccess($t('TokenAdded'));
      } catch (e) {
        console.error('token add failed', e);
        upError($t('TokenAddFailed'));
      } finally {
        coinStore.tokenLists[_token.chain] = coinStore.tokenLists[_token.chain].map(token => {
          if (isSameAddress(token.contractAddress, _token.contractAddress)) {
            return { ...token,
              loading: false
            };
          }

          return token;
        });
      }
    };

    const addCustomToken = () => {
      $emit('close');
      $emit('addCustomToken');
    };

    const deleteToken = token => {
      ElMessageBox.confirm($t('DeleteTokenConfirm', {
        token: token.symbol
      }), $t('DeleteToken'), {
        showClose: false,
        confirmButtonText: $t('Delete'),
        cancelButtonText: $t('Cancel'),

        async beforeClose(action, instance, done) {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonDisabled = true;
            await coinStore.removeTokenFromTokenList(userStore.chainId, token.contractAddress);
            done();
          } else {
            done();
          }
        }

      }).catch(() => {});
    };

    return (_ctx, _cache) => {
      const _component_up_icon = __unplugin_components_0;

      const _component_up_token = __unplugin_components_1;

      const _component_up_button = __unplugin_components_2;

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: _normalizeClass(['header', _unref(isMobile)() ? 'tokens-padding-mobile' : 'tokens-padding'])
      }, [_createVNode(_component_up_icon, {
        class: "header-close",
        name: "close",
        onClick: _cache[0] || (_cache[0] = $event => $emit('close'))
      }), _createElementVNode("div", _hoisted_2, _toDisplayString(_unref($t)('ManageTokens')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getChainName)(_unref(getChainNameByChainId)(_unref(userStore).chainId))), 1)], 2), _createElementVNode("div", {
        class: _normalizeClass(['tokens-wrap', _unref(isMobile)() ? 'tokens-wrap-padding-mobile' : 'tokens-wrap-padding'])
      }, [_unref(myTokens).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)('MyTokens')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(myTokens), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "token",
          key: item.contractAddress
        }, [_createVNode(_component_up_token, {
          symbol: item.symbol,
          name: item.name,
          chain: item.chain,
          icon: item.logoURI,
          subtitleFontSize: '12px',
          type: "index"
        }, null, 8, ["symbol", "name", "chain", "icon"]), _createVNode(_component_up_icon, {
          style: {
            "cursor": "pointer"
          },
          class: "button",
          height: "16",
          width: "16",
          name: "delete",
          onClick: $event => deleteToken(item)
        }, null, 8, ["onClick"])]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref($t)('Top100Tokens')), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(top100Tokens), item => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["token", {
            added: item.added
          }]),
          key: item.contractAddress
        }, [_createVNode(_component_up_token, {
          name: item.name,
          symbol: item.symbol,
          chain: item.chain,
          icon: item.logoURI,
          "contract-address": item.contractAddress,
          subtitleFontSize: '12px',
          type: "index"
        }, null, 8, ["name", "symbol", "chain", "icon", "contract-address"]), item.loading ? (_openBlock(), _createBlock(_component_up_icon, {
          key: 0,
          name: "loading",
          height: "16",
          width: "16",
          class: "is-loading duration"
        })) : item.added ? (_openBlock(), _createBlock(_component_up_icon, {
          key: 1,
          class: "button",
          height: "16",
          width: "16",
          name: "add-token-success"
        })) : (_openBlock(), _createBlock(_component_up_icon, {
          key: 2,
          class: "button",
          name: "add-token",
          height: "16",
          width: "16",
          onClick: $event => addToken(item)
        }, null, 8, ["onClick"]))], 2);
      }), 128))])], 2), _createElementVNode("div", {
        class: _normalizeClass(['button-box', _unref(isMobile)() ? 'button-box-padding-mobile' : 'button-box-padding'])
      }, [_createVNode(_component_up_button, {
        type: "info",
        onClick: addCustomToken
      }, {
        default: _withCtx(() => [_createVNode(_component_up_icon, {
          name: "add-token"
        }), _createTextVNode(" " + _toDisplayString(_unref($t)('AddCustomToken')), 1)]),
        _: 1
      })], 2)]);
    };
  }

});